import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import '../styles/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2>Page Not Found</h2>
        <p>
          Oops! The page you're looking for doesn't exist. 
          It might have been moved or deleted.
        </p>
        <Link to="/">
          <Button variant="primary">
            Go Back Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
